import { useContext } from "react";
import jwt_decode from "jwt-decode";
import { useMutation, useQuery } from "react-query";

import {
  loginUser,
  getUserInfo,
  logoutUser,
  loginThirdParty,
  checkMail,
  registerUser,
  forgotPassword,
  refreshUser,
} from "../../api/auth";
import DataContext from "../../context/dataContext";
import PortalContext from "../../context/portalContext";

export const AUTH_QUERY_KEY = "auth";

export const useLoginUser = () => {
  const { setAuth, setAuthErrors, setAuthErrorObject, setSuccessMsgs } =
    useContext(DataContext);
  const { closeAuthPortals } = useContext(PortalContext);

  const mutation = useMutation(
    ({ params }: { params: any }) => loginUser({ params }),
    {
      onSuccess: (data) => {
        localStorage.setItem("access-token", data.data?.access);
        localStorage.setItem("refresh-token", data.data?.refresh);

        if (data.data.access) {
          const verify = jwt_decode<any>(data.data?.access);

          if (verify) {
            setAuth(true);
            closeAuthPortals();
            setSuccessMsgs((prev) => [
              ...prev,
              "თქვენ წარმატებით გაიარეთ ავტორიზაცია",
            ]);
          }
        }
      },
      onError: (error) => {
        const HandleAsyncError = async (error) => {
          try {
            setAuthErrors(["ავტორიზაცია წარუმატებელია"]);
            setAuthErrorObject([
              {
                msg: "მომხმარებლის სახელი ან პაროლი არასწორია",
                type: "email",
              },
            ]);
          } catch (fail) {
            console.log("fail");
            setAuthErrors(["ავტორიზაცია წარუმატებელია"]);
          }
        };
        HandleAsyncError(error);
      },
    }
  );
  return {
    loginUser: async ({ params }: { params: any }) => {
      await mutation.mutateAsync({ params });
    },
    loading: mutation.isLoading,
    status: mutation.status,
    isError: mutation.isError,
    data: mutation.data?.data,
  };
};
export const useLoginThirdParty = () => {
  const { setAuth, setAuthErrors, setSuccessMsgs } = useContext(DataContext);
  const { closeAuthPortals } = useContext(PortalContext);

  const mutation = useMutation(
    ({ params }: { params: any }) => loginThirdParty({ params }),
    {
      onSuccess: (data) => {
        localStorage.setItem("access-token", data.data?.access);
        localStorage.setItem("refresh-token", data.data?.refresh);
        if (data?.data?.access) {
          const verify = jwt_decode<any>(data.data?.access);

          if (verify) {
            setAuth(true);
            closeAuthPortals();
            setSuccessMsgs((prev) => [
              ...prev,
              "თქვენ წარმატებით გაიარეთ ავტორიზაცია",
            ]);
          }
        }
      },
      onError: (error) => {
        const HandleAsyncError = async (error) => {
          try {
            setAuthErrors(["ავტორიზაცია წარუმატებელია"]);
          } catch (fail) {
            console.log("error");
          }
        };
        HandleAsyncError(error);
      },
    }
  );
  return {
    loginThirdParty: async ({ params }: { params: any }) => {
      await mutation.mutateAsync({ params });
    },
    loading: mutation.isLoading,
    status: mutation.status,
    isError: mutation.isError,
    data: mutation.data?.data,
  };
};
export const useForgotPassword = () => {
  const { setAuthErrors, setSuccessMsgs } = useContext(DataContext);

  const mutation = useMutation(
    ({ params }: any) => forgotPassword({ params }),
    {
      onSuccess: (data) => {
        setSuccessMsgs((prev) => [...prev, data.data?.detail]);
      },
      onError: (error) => {
        const HandleAsyncError = async (error) => {
          try {
            setAuthErrors((prev) => [...prev, error.response.data.email[0]]);
          } catch (fail) {
            console.log("nothing");
          }
        };
        HandleAsyncError(error);
      },
    }
  );
  return {
    forgotPassword: async ({ params }) => {
      await mutation.mutateAsync({ params });
    },
    error: mutation.isError,
    loading: mutation.isLoading,
    status: mutation.status,
  };
};
export const useGetUserInfo = () => {
  const query = useQuery(
    AUTH_QUERY_KEY + "getuser",
    async () => getUserInfo(),
    {
      refetchOnWindowFocus: false,
    }
  );

  return query;
};

export const useLogoutUser = () => {
  const { setSuccessMsgs } = useContext(DataContext);

  const mutation = useMutation(() => logoutUser(), {
    onSuccess: () => {
      setSuccessMsgs((prev) => [
        ...prev,
        "თქვენ წარმატებით გამოხვედით სისტემიდან",
      ]);
    },
  });
  return {
    logoutUser: async () => {
      await mutation.mutateAsync();
    },
    error: mutation.isError,
    loading: mutation.isLoading,
    status: mutation.status,
  };
};
export const useRefreshUser = () => {
  const { setAuth, setSuccessMsgs } = useContext(DataContext);
  const { closeAuthPortals } = useContext(PortalContext);

  const mutation = useMutation(
    ({ refreshToken }: any) => refreshUser({ refreshToken }),
    {
      onSuccess: (data) => {
        // console.log(data);
        const { access } = data.data;

        localStorage.setItem("access-token", access);

        const checkUser = (access: string) => {
          if (access) {
            const verify = jwt_decode<any>(access);

            if (verify) {
              setAuth(true);
              closeAuthPortals();
              // setSuccessMsgs((prev) => [
              //   ...prev,
              //   "თქვენ წარმატებით გაიარეთ ავტორიზაცია",
              // ]);
            }
          }
        };
        checkUser(access);
      },
    }
  );
  return {
    refreshUser: async ({ refreshToken }) => {
      await mutation.mutateAsync({ refreshToken });
    },
    error: mutation.isError,
    loading: mutation.isLoading,
    status: mutation.status,
  };
};
export const useCheckMail = () => {
  const { setAuthErrors } = useContext(DataContext);

  const mutation = useMutation((params: any) => checkMail(params), {
    onSuccess: (data) => {
      if (data.code === "EC002") {
        setAuthErrors((prev) => [...prev, data.detail]);
      }
      if (data.code === "EC001") {
        setAuthErrors((prev) => prev.slice(0, -1));
      }
    },
  });
  return {
    checkMail: async (params) => {
      await mutation.mutateAsync(params);
    },
    error: mutation.isError,
    loading: mutation.isLoading,
    status: mutation.status,
  };
};
export const useRegisterUser = () => {
  const { setAuthErrorObject, setSuccessMsgs, setAuth } =
    useContext(DataContext);
  const { closeAuthPortals } = useContext(PortalContext);

  const mutation = useMutation(({ params }: any) => registerUser({ params }), {
    onSuccess: (data) => {
      localStorage.setItem("access-token", data.data?.tokens.access);
      localStorage.setItem("refresh-token", data.data?.tokens.refresh);

      if (data.data?.tokens.access) {
        const verify = jwt_decode<any>(data.data.tokens.access);

        if (verify) {
          setSuccessMsgs((prev) => [
            ...prev,
            data?.data?.detail || "თქვენ წარმატებით გაიარეთ რეგისტრაცია",
          ]);
          closeAuthPortals();
          setAuth(true);
        }
      }
    },
    onError: (error) => {
      const HandleAsyncError = async (error) => {
        try {
          const data = error?.response?.data;
          let errorArrary = [];
          // console.log("error", data);
          Object.keys(data).forEach(function (key) {
            if (Array.isArray(data[key])) {
              // in-form ui errors
              if (
                key === "email" ||
                key === "username" ||
                key === "phone" ||
                key === "password"
              ) {
                return errorArrary.push({ msg: data[key][0], type: key });
              }
            }
            return null;
          });
          return setAuthErrorObject(errorArrary);
          // setAuthErrors("fail register");
        } catch (fail) {
          console.log("fail", fail);
        }
      };
      HandleAsyncError(error);
    },
  });
  return {
    registerUser: async ({ params }) => {
      await mutation.mutateAsync({ params });
    },
    error: mutation.isError,
    loading: mutation.isLoading,
    status: mutation.status,
  };
};
